import { useEffect, useRef } from 'react';
import text from '../text';
import useUser from '../mp/hooks/useUser';
import { alertSuccess } from '../redux/actions';
import { useAppDispatch } from './useAppDispatch';
import { useUpdateLoginEmailBannerFlagMutation } from '../redux/rtk';
import { ReactSVG } from 'react-svg';

const useOnLoginEmailBanner = () => {
  const { profile, isSuccess } = useUser();
  const dispatch = useAppDispatch();
  const [updateLoginEmailBannerFlag] = useUpdateLoginEmailBannerFlagMutation();
  const shouldShowBanner =
    Boolean(profile?.should_show_email_banner) && isSuccess;

  useEffect(() => {
    if (!shouldShowBanner) {
      return;
    }
    dispatch(
      alertSuccess(
        <div className='d-flex align-items-center justify-content-center'>
          <ReactSVG src='/public/img/circled-check.svg' className='mr-2' />
          <span>
            {text('onLoginEmailBanner')}
            <strong className='mr-1 white-underlined-link'>
              {profile?.email}.
            </strong>
            {text('onLoginEmailBannerEnd')}
          </span>
        </div>,
        {
          dismissible: true,
          autoDismiss: false,
          persistOnNavigation: true,
          onDismiss: () =>
            updateLoginEmailBannerFlag({ should_show_email_banner: false }),
          className: 'on-login-email-banner',
        }
      )
    );
  }, [dispatch, profile?.email, shouldShowBanner, updateLoginEmailBannerFlag]);
};

export default useOnLoginEmailBanner;
